import React, {Component} from 'react';
import Question from './question';
import axios from 'axios';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import './question.scss';
import Nav from '../Nav/index';
import withAuth from "../../services/withAuth";
import ProgressBar from './progress-bar';
import AuthService from "../../services/authService";

class Questions extends Component {

    constructor(props) {
        super(props);
        this.config = {
            headers: {'Authorization': "bearer " + AuthService.getToken()}
        };

        this.state = {
            answers: [],
            questions: null,
            showQuestion: true,
            questionIndex: 0,
            progress: 0,
            showMenu: false,
        }
        this.answers = [];
        this.questionList = [];

        this.progress = 0;


        this.questions = []
    }

    componentDidMount() {
        this.getQuestions();
    }

    // use top when hooked up
    async getQuestions() {
        let dataURL = "https://onamfc.com/api/assessment-questions";


        await axios.get(dataURL, this.config).then(response => {
            // console.log("Questions array", response);
            this.questions = response.data;
            // loop through the questions array
            // console.log("loop lengths", this.questions.length, this.questions[0].assessment_question.length)
            for (let i = 0; i < this.questions.length; i++) {
                for (let j = 0; j < this.questions[i].assessment_question.length; j++) {
                    // Generate a question Components in order
                    // When it is clicked generate the next question
                    let questionComponent = <Question
                        question={this.questions[i].assessment_question[j].question}
                        core_category_id={this.questions[i].assessment_question[j].core_category_id}
                        nextQuestion={this.nextQuestion.bind(this)}
                        key={Math.random() * 1000}
                    />
                    this.questionList.push(questionComponent);
                    // console.log("Question List", this.questionList);
                }

            }
            this.setState({
                questions: this.questionList
            })
        })
    }


    nextQuestion(e) {

        // console.log("Check this Event", e.target);
        let checkSource = e.target;
        checkSource = checkSource.className.split(' ');
        if (checkSource.includes("checkbox-container")) {
            return;
        }

        this.handleQuestionClick();
        let category_id;
        let option = e.target.name;
        if (!option) {
            this.handleQuestionClick();
            return;
        }

        let value = parseInt(e.target.value);
        let question = e.currentTarget;

        category_id = parseInt(question.getAttribute("category_id"));
        question = question.getAttribute("question");

        let answerObj = {
            option,
            value,
            question,
            category_id
        }
        this.answers.push(answerObj);
        setTimeout(() => {
                let checkbox = document.querySelectorAll('input[type=checkbox]');
                checkbox = [...checkbox];
                checkbox.forEach(input => {
                    input.checked = false;
                })
            }
            , 500);
        setTimeout(this.loadNextQuestion.bind(this), 500);
    }


    loadNextQuestion() {
        let questionNumber = this.state.questionIndex;
        // console.log(questionNumber, this.questionList.length)
        // If the last question is answered submit answers array
        if (this.questionList.length === questionNumber + 1) {
            this.submitAnswers(this.answers);
        }
        questionNumber++;
        this.setState({
            questionIndex: questionNumber
        })
        this.handleQuestionClick();
        this.handleQuestionClick();
        this.move()
    }

    previousQuestion() {
        if (this.state.questionIndex > 0) {
            this.handleQuestionClick();
            this.answers.pop();
            let questionNumber = this.state.questionIndex;
            questionNumber--;
            this.setState({
                questionIndex: questionNumber
            });

            setTimeout(this.handleQuestionClick, 500);
            this.moveBack()
        }
    }

    // Need Bearer Token to work

    async submitAnswers(answerObj) {

        let dataURL = "https://onamfc.com/api/assessment-answers";
        try {
            // RESPONSE = USER OBJECT
            await axios.post(dataURL, {answers: answerObj}, this.config).then(response => {
                AuthService.setUser(response.data)
                this.props.history.replace('/assessment-complete');

            });
        } catch (e) {
            // TODO: HANDLE ERROR
        }


    }

    handleQuestionClick = () => {
        this.setState({
            showQuestion: !this.state.showQuestion
        })
    }

    // Progress Bar function
    move() {
        // var elem = document.getElementById("myBar");
        var width = 100 / (this.questionList.length)
        this.progress += width;
        this.setState({
            progress: this.state.progress += width

        })


        // if (this.displayProgressBar(this.questionList, this.state.questionIndex)) {
        //     elem.style.width = this.progress + '%';
        //     elem.innerHTML = Math.round(this.progress) + '%';
        // }

    }

    moveBack() {
        // var elem = document.getElementById("myBar");
        var width = 100 / this.questionList.length
        this.progress -= width;
        this.setState({
            progress: this.state.progress -= width

        })
        // elem.style.width = this.progress + '%';
        // elem.innerHTML = Math.round(this.progress) + '%';

    }

    // end progress bar function


    static getSingleQuestion(questionList, questionIndex) {
        return questionIndex === questionList.length ? false : questionList[questionIndex].props.question
    }

    static getCategoryId(questionList, questionIndex) {
        return questionIndex === questionList.length ? false : questionList[questionIndex].props.core_category_id
    }

    displayProgressBar(questionList, questionIndex) {
        return questionIndex === questionList.length ? false : <ProgressBar percentage={this.state.progress}/>
    }

    handleClick = (e) => {

        // console.log("click triggered",e.target);
        this.setState({
            showMenu: !this.state.showMenu
        })
    }

    handleClose = (e) => {
        let target = e.target;

        if (target.classList.contains('large-text') || target.classList.contains('menu-list') || target.classList.contains('small-text') || target.classList.contains('social-icon') || target.classList.contains('menu-slideout') || target.classList.contains('menu-button')){
            return;
        }

        // if (target.classList.contains('close-menu')){
            if(this.state.showMenu){
                this.setState({
                    showMenu: false
                })
            }
        // }
        // console.log("close triggered" ,e.target);
    }


    render() {
        // console.log("this.answers", this.answers);
        if (this.state.questions === null) {
            return (
                <div>
                    <Nav showMenu = {this.state.showMenu} handleClick = {this.handleClick} handleClose ={this.handleClose} />
                    <div>Loading questions</div>
                </div>
            )
        } else {
            return (
                <div>
                    <Nav showMenu = {this.state.showMenu} handleClick = {this.handleClick} handleClose ={this.handleClose} />
                    <div id="question-container" className="container">
                        {this.displayProgressBar(this.questionList, this.state.questionIndex)}
                        <CSSTransitionGroup
                            transitionName="fade"
                            transitionEnterTimeout={700}
                            transitionLeaveTimeout={700}
                        >
                            {this.state.showQuestion &&
                            <Question
                                questionIndex={this.state.questionIndex}
                                question={Questions.getSingleQuestion(this.questionList, this.state.questionIndex)}
                                core_category_id={Questions.getCategoryId(this.questionList, this.state.questionIndex)}
                                nextQuestion={this.nextQuestion.bind(this)}
                                previousQuestion={this.previousQuestion.bind(this)}
                            />
                            }
                        </CSSTransitionGroup>


                    </div>
                </div>
            )
        }

    }


}

export default withAuth(Questions);
